import script from "./ConfirmTips.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmTips.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmTips.vue?vue&type=style&index=0&id=734877f4&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-734877f4"]])

export default __exports__